import { render } from "./OrderChat.vue?vue&type=template&id=077a6148&scoped=true"
import script from "./OrderChat.vue?vue&type=script&lang=js"
export * from "./OrderChat.vue?vue&type=script&lang=js"

import "./OrderChat.vue?vue&type=style&index=0&id=077a6148&scoped=true&lang=css"

import exportComponent from "/home/cm/project/golinker/admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-077a6148"]])

export default __exports__